// Navigation.js
import React from 'react';
import './App.css'; // Import your styles here

const Navigation = () => {
  return (
    <div className="navigation">
      <ul>
        <li><a href="#home">HOME</a></li>
        <li><a href="#about">ABOUT ME</a></li>
        <li><a href="#projects">PROJECTS</a></li>
      </ul>
    </div>
  );
};

export default Navigation;
